import type { HttpClient } from '../http';
import { unwrap, type ApiEnvelope } from '../envelope';
import type { BillingSummary, PlatformSubscription, SubscriptionDetail, PlatformInvoice, CreateSubscriptionRequest, UpdateSubscriptionRequest, PayInvoiceRequest } from '../types/domain';

export function platformBillingEndpoints(http: HttpClient) {
  return {
    summary: () => http.get<ApiEnvelope<BillingSummary>>('/v1/platform/billing/summary').then(unwrap),
    subscriptions: (status?: string) => http.get<ApiEnvelope<PlatformSubscription[]>>('/v1/platform/billing/subscriptions', { query: { status } }).then(unwrap),
    subscription: (id: string) => http.get<ApiEnvelope<SubscriptionDetail>>(`/v1/platform/billing/subscriptions/${id}`).then(unwrap),
    createSubscription: (body: CreateSubscriptionRequest) => http.post<ApiEnvelope<PlatformSubscription>>('/v1/platform/billing/subscriptions', body).then(unwrap),
    updateSubscription: (id: string, body: UpdateSubscriptionRequest) => http.patch<ApiEnvelope<PlatformSubscription>>(`/v1/platform/billing/subscriptions/${id}`, body).then(unwrap),
    payInvoice: (id: string, body: PayInvoiceRequest) => http.post<ApiEnvelope<PlatformInvoice>>(`/v1/platform/billing/invoices/${id}/pay`, body).then(unwrap),
  };
}
export type PlatformBillingEndpoints = ReturnType<typeof platformBillingEndpoints>;
